import { Container } from "@mui/system";
import axios from "axios";
import React from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import "./App.css";
import Navbar from "./components/Navbar";

import "firebase/compat/firestore";
import "firebase/compat/storage";

import { Send } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  FormControl,
  FormHelperText,
  MenuItem,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { StyledInput, StyledPhoneInput } from "./components/StyledInput";

import "react-phone-input-2/lib/style.css";

type Inputs = {
  first_name: string;
  phone_number: string;
  region: string;
  branch: string;
  comment?: string;
};

const regions = [
  {
    region: "Toshkent shahri",
    branches: [
      {
        name: "Chilonzor filiali",
        value: "Chilonzor filiali",
      },
      {
        name: "Yunusobod filiali",
        value: "Yunusobod filiali",
      },

      {
        name: "Sergeli filiali",
        value: "Sergeli filiali",
      },

      {
        name: "Qo’yliq filiali",
        value: "Qo’yliq filiali",
      },

      {
        name: "Uchtepa filiali",
        value: "Uchtepa filiali",
      },
      {
        name: "Yakkasaroy filiali",
        value: "Yakkasaroy filiali",
      },
      {
        name: "Mirzo Ulug’bek filiali",
        value: "Mirzo Ulug’bek filiali",
      },
      {
        name: "Shayhontohur filiali",
        value: "Shayhontohur filiali",
      },
      {
        name: "Olmazor filiali",
        value: "Olmazor filiali",
      },
    ],
  },
  {
    region: "Samarqand viloyati",
  },
  {
    region: "Farg'ona viloyati",
    branches: [
      {
        name: "Farg'ona shahri filiali",
        value: "Farg'ona filiali",
      },
      {
        name: "Rishton filiali",
        value: "Rishton-Farg'ona filiali",
      },
      {
        name: "Qo'qon filiali",
        value: "Qo'qon filiali",
      },
    ],
  },
  {
    region: "Qashqadaryo viloyati",
  },
  {
    region: "Namangan viloyati",
  },
  {
    region: "Andijon viloyati",
  },
  {
    region: "Xorazm viloyati",
  },
  {
    region: "Navoiy viloyati",
  },
  {
    region: "Jizzax viloyati",
  },
];

function App() {
  const { t } = useTranslation();
  const [uploading, setUploading] = React.useState<boolean>(false);
  const {
    register,
    handleSubmit,
    control,
    watch,
    reset,
    formState: { errors },
    setValue,
  } = useForm<Inputs>();

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    // try {
    //   await db.collection("users").add({
    //     timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    //     first_name: data.first_name,
    //     last_name: data.last_name,
    //     region: data.region,
    //     branch: data.branch,
    //     comment: data.comment,
    //   });
    // } catch (error) {
    //   toast.error(t("form.error"), {
    //     position: "top-center",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "light",
    //     transition: Bounce,
    //   });
    // }
    setUploading(true);
    await axios
      .post("https://api.systematicdev.uz/rgn-edu-api/", {
        name: data.first_name,
        phone: data.phone_number,
        ...(data.region === "Toshkent shahri"
          ? {
              area: data.branch,
              region: data.region,
            }
          : data.region === "Farg'ona viloyati"
          ? { region: "Fargona viloyati", branch: data.branch }
          : { region: data.region }),
        // comment: data.comment,
      })
      .then(function (responses: any) {
        // console.log(responses);
        setUploading(false);
        toast.success(t("form.success"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        reset();
      })
      .catch(function (error: any) {
        // console.log(error);
        setUploading(false);
        toast.error(t("form.error"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      });
    // reset();
  };

  const resetData = () => {
    toast.warning(t("form.clear"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
    reset();
  };

  return (
    <div className="App">
      <Navbar />
      <Box>
        <Container>
          <ToastContainer />
          <Paper
            sx={{ maxWidth: "700px", m: "auto", mt: 3, p: 3, borderRadius: 3 }}
          >
            <form
              noValidate
              autoComplete="off"
              onSubmit={handleSubmit(onSubmit)}
            >
              <Typography variant="body1" fontWeight="bold">
                {t("form.title")}
              </Typography>
              <Stack direction="column" spacing={3} mt={3}>
                <StyledInput
                  error={errors.first_name?.type === "required" && true}
                  helperText={
                    errors.first_name?.type === "required" &&
                    t("form.input_required")
                  }
                  label={t("form.first_name")}
                  placeholder={t("form.placeholder_there")}
                  fullWidth
                  required
                  {...register("first_name", { required: true })}
                />
                <Controller
                  control={control}
                  name="phone_number"
                  rules={{
                    required: {
                      value: true,
                      message: "Start date is required",
                    },
                  }}
                  render={({ field: { ref, ...field } }) => (
                    <FormControl>
                      <StyledPhoneInput
                        {...field}
                        country={"uz"}
                        onlyCountries={["uz"]}
                        inputProps={{
                          ref,
                          required: true,
                        }}
                        placeholder="+998"
                      />
                      <FormHelperText
                        id="my-helper-text"
                        error={errors.phone_number?.type === "required" && true}
                      >
                        {errors.phone_number?.type === "required" &&
                          t("form.input_required")}
                      </FormHelperText>
                    </FormControl>
                  )}
                />

                <StyledInput
                  error={errors.region?.type === "required" && true}
                  helperText={
                    errors.region?.type === "required" &&
                    t("form.input_required")
                  }
                  select
                  fullWidth
                  label={t("form.region")}
                  inputProps={register("region", {
                    required: "Please enter ielts score",
                  })}
                >
                  {regions.map((option, index) => (
                    <MenuItem key={index} value={option.region}>
                      {option.region}
                    </MenuItem>
                  ))}
                </StyledInput>

                <StyledInput
                  error={errors.branch?.type === "required" && true}
                  helperText={
                    errors.branch?.type === "required" &&
                    t("form.input_required")
                  }
                  select
                  fullWidth
                  label={
                    watch("region") === regions[0].region
                      ? t("form.district")
                      : t("form.branch")
                  }
                  inputProps={register("branch")}
                  value={watch("branch") || ""}
                  sx={{
                    display: regions.find(
                      (region) => region.region === watch("region")
                    )?.branches
                      ? watch("region")
                        ? "block"
                        : "none"
                      : "none",
                  }}
                >
                  {watch("region") ? (
                    regions
                      .find((region) => region.region === watch("region"))
                      ?.branches?.map((branch, index) => (
                        <MenuItem key={index} value={branch.value}>
                          {branch.name}
                        </MenuItem>
                      ))
                      .concat(
                        <MenuItem key="Ma'lum emas!" value="Ma'lum emas!">
                          {t("form.no_near_branch")}
                        </MenuItem>
                      )
                  ) : (
                    <MenuItem value="">Viloyatni tanlang</MenuItem>
                  )}
                </StyledInput>

                {/* <StyledInput
                  error={errors.comment?.type === "required" && true}
                  helperText={
                    errors.comment?.type === "required" &&
                    t("form.input_required")
                  }
                  label={t("form.comment")}
                  placeholder={t("form.placeholder_there")}
                  fullWidth
                  multiline
                  rows={2}
                  {...register("comment", { required: false })}
                /> */}
              </Stack>
              <Stack
                direction="row"
                mt={2}
                spacing={2}
                justifyContent="flex-end"
              >
                <LoadingButton
                  disableElevation
                  type="submit"
                  loading={uploading}
                  loadingPosition="start"
                  startIcon={<Send />}
                  variant="contained"
                >
                  {t("form.submit")}
                </LoadingButton>
              </Stack>
            </form>
          </Paper>
          <Typography align="center" mt={3}>
            {t("slogan")}
          </Typography>
        </Container>
      </Box>
    </div>
  );
}

export default App;
